import {mapState, mapMutations} from "vuex";
import {updateLotsRoute} from "../helpers";

export default {
  computed: {
    ...mapState(['lotQueryParams']),
    fields() {
      const mapper = {
        'FavoriteLots': {
          queryParams: this.lotQueryParams,
          setFilters: this.setLotFilters,
          updateRoute: updateLotsRoute
        },
        'default': {
          queryParams: this.lotQueryParams,
          setFilters: this.setLotFilters,
          updateRoute: updateLotsRoute
        }
      }

      return this.$route.name in mapper ? mapper[this.$route.name] : mapper['default'];
    },
  },
  methods: {
    ...mapMutations(['setLotFilters'])
  },
}
